export default "__VITE_ASSET__B8P4beo1__"